import apiPath from "../config/api-path";
import httpRequest from "../config/http-api";

export default {
  getCategoryList(config, { success, error }) {
    const {
      category: { list },
    } = apiPath;
    return httpRequest.getRequest(list, success, error, config);
  },

  createCategory(data, { success, error }) {
    const {
      category: { create },
    } = apiPath;
    return httpRequest.postRequest(create, data, success, error);
  },
};
